<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "NewJob",
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
</style>